import React from 'react';
import { Typography, Box } from '@mui/material';

const buildHash = process.env.REACT_APP_BUILD_HASH || 'dev';
const buildTime = process.env.REACT_APP_BUILD_TIME || '';

const formatTime = (iso: string): string => {
  if (!iso) return '';
  try {
    const d = new Date(iso);
    return d.toISOString().replace('T', ' ').slice(0, 16) + ' UTC';
  } catch {
    return iso;
  }
};

const BuildInfo: React.FC = () => {
  const label = buildTime
    ? `v ${buildHash} | ${formatTime(buildTime)}`
    : `v ${buildHash}`;

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 4,
        right: 8,
        zIndex: 1,
        pointerEvents: 'none',
        userSelect: 'none',
      }}
    >
      <Typography
        variant="caption"
        sx={{ opacity: 0.35, fontSize: '0.65rem', fontFamily: 'monospace' }}
      >
        {label}
      </Typography>
    </Box>
  );
};

export default BuildInfo;
